export default __webpack_public_path__ + "static/media/989.ba623273.png";